import { render, staticRenderFns } from "./EmpresaParceiraCriar.vue?vue&type=template&id=3f7bc366"
import script from "./EmpresaParceiraCriar.vue?vue&type=script&lang=js"
export * from "./EmpresaParceiraCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports